import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "./slice";

const selectDomain = (state) => state.reviewReports || initialState;

export const selectLoading = createSelector([selectDomain], (state) => state.loading);
export const selectReports = createSelector([selectDomain], (state) => state.reports);
export const selectError = createSelector([selectDomain], (state) => state.error);
export const selectTotalReports = createSelector([selectDomain], (state) => state.totalReports);
export const selectCommodities = createSelector([selectDomain], (state) => state.commodities);
export const selectPersistedFilters = createSelector(
  [selectDomain],
  (state) => state.persistedFilters
);